module.exports = __webpack_public_path__ + "img/Garage-Icon.d83e9b04.webp";